export const FALLBACK_THREAD_TITLE = 'Nova conversa';

export const normalizeThreadTitle = (title?: string | null) => {
  if (!title) return FALLBACK_THREAD_TITLE;

  const normalizedTitle = title.trim().replace(/^"+/, '').replace(/"+$/, '').trim().replace(/\s+/g, ' ');

  return normalizedTitle || FALLBACK_THREAD_TITLE;
};
